import React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { TopHeader, CTNavbar } from "../components";
import { ProviderLandingPage, AdminLandingPage, UserLandingPage, AccessLandingPage } from "../pages";
import { Navigate } from 'react-router-dom';
import { setSelectedFamilyMember } from "apiServices/reducer/apiService";
import { rememberPasskeySetupFromUrl, shouldOpenPasskeySecurity, confirmPasskeySetupForLoggedInUser } from "../services/passkeyService";


const LandingPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("All");
  const [navItems, setNavItems] = useState([]);
  const MenuData = useSelector((state) => state.apiService.menuItem);
  const FamilyData = useSelector((state) => state.apiService.familyAccounts);
  const login = useSelector((state) => state.apiService.login);
  const token = useSelector((state) => state.apiService.token);
  const userRole = login?.user_type_name;
  const accessType = login?.role;

  const hasValidSession = useMemo(() => {
    if (typeof token === 'string' && token.trim().length > 0) return true;
    if (
      login &&
      typeof login === 'object' &&
      login.Token != null &&
      String(login.Token).trim() !== ''
    ) {
      return true;
    }
    return false;
  }, [token, login]);
  const [familyItems, setFamilyItems] = useState([]);
  const [activeParentId, setActiveParentId] = useState(null)
  const selectedFamilyMemberFromStore = useSelector((state) => state.apiService.selectedFamilyMember);
  const [selectedFamilyMember, setSelectedFamilyMember] = useState(selectedFamilyMemberFromStore);
  const [selectedUserId, setSelectedUserId] = useState(selectedFamilyMemberFromStore?.user_id || login?.user_id);
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [activeMenuItem, setActiveMenuItem] = useState
    ({
      showUsersList: false,
      showUserReports: false,
      showSharedReports: false,
      showBlog: false,
      showPatientConversation: false,
      showBMI: false,
      showReport: false,
      showNotes: false,
      showAskAcme: false,
      showSecondOpinion: false,
      showProfile: false,
      showReceipt: false,
      showDashBoard: false,
      showReports: false,
      showViewSharedReports: false,
      showMedicalCondition: false,
      showScheduleForChildren: false,
      showScheduleByAge: false,
      showTrueContraindications: false,
      showAdministeringVaccinesToAdults: false,
      showChangePassword: false,
      showAccessDashboard: false,
      showAccessViewSharedReports: false,
    })

  const setActiveMenuItems = (event) => {
    console.log("event", event)

    // Handle profile navigation specifically
    if (event === 'profile') {
      console.log("Profile navigation triggered");
      const newActiveMenuItem = {
        showUsersList: false,
        showUserReports: false,
        showSharedReports: false,
        showBlog: false,
        showPatientConversation: false,
        showBMI: false,
        showReports: false,
        showNotes: false,
        showAskAcme: false,
        showSecondOpinion: false,
        showReceipt: false,
        showDashBoard: false,
        showMedicalCondition: false,
        showScheduleForChildren: false,
        showScheduleByAge: false,
        showTrueContraindications: false,
        showAdministeringVaccinesToAdults: false,
        showAccessDashboard: false,
        showProfile: true,
        showAccessViewSharedReports: false,
      };
      setActiveParentId(null)
      console.log("newActiveMenuItem for profile", newActiveMenuItem)
      setActiveMenuItem(newActiveMenuItem);
      return;
    }

    if (event && typeof event === 'object' && Number(event.parent_id) === 2) {
      const categoryTitle = event.title || event.name || '';
      const matchedCategory = navItems.find((item) =>
        Number(item.parent_id) === 2 && (
          (event.id && String(item.id) === String(event.id)) ||
          (categoryTitle && String(item.title).toLowerCase() === String(categoryTitle).toLowerCase())
        )
      );
      if (matchedCategory) event = matchedCategory;
    }

    const isAskAcmeMenu =
      event.menu_id === 28 ||
      event.url === '/ask-acme' ||
      event.url === 'ask-acme';

    const newActiveMenuItem = {
      showUsersList: Number(event.menu_id) === 10,
      showUserReports: Number(event.menu_id) === 11,
      showSharedReports: (Number(event.menu_id) === 4 && event.parent_id == null),
      showBlog: (Number(event.menu_id) === 5 && event.parent_id == null),
      showPatientConversation: Number(event.menu_id) === 25,
      showBMI: (Number(event.parent_id) === 14 && Number(event.menu_id) === 23)||(Number(event.parent_id) === 1012 && Number(event.menu_id) === 1018),
      showReports: (Number(event.parent_id) === 2),
      showNotes: (Number(event.menu_id) === 21)||(Number(event.menu_id) === 1020),
      showAskAcme: isAskAcmeMenu,
      showSecondOpinion: Number(event.menu_id) === 8,
      showReceipt: (Number(event.parent_id) === 12 && Number(event.menu_id) === 13)||(Number(event.parent_id) === 1010 && Number(event.menu_id) === 1011),
      showDashBoard: (Number(event.menu_id) === 1 && event.parent_id == null),
      showMedicalCondition: (Number(event.parent_id) === 15 && Number(event.menu_id) === 16)||(Number(event.parent_id) === 1013 && Number(event.menu_id) === 1014),
      showScheduleForChildren: (Number(event.parent_id) === 15 && Number(event.menu_id) === 17)||(Number(event.parent_id) === 1013 && Number(event.menu_id) === 1015),
      showScheduleByAge: (Number(event.parent_id) === 15 && Number(event.menu_id) === 18)||(Number(event.parent_id) === 1013 && Number(event.menu_id) === 1016),
      showTrueContraindications: (Number(event.parent_id) === 15 && Number(event.menu_id) === 19)||(Number(event.parent_id) === 1013 && Number(event.menu_id) === 1017),
      showAdministeringVaccinesToAdults: (Number(event.parent_id) === 15 && Number(event.menu_id) === 20),
      showAccessDashboard: Number(event.menu_id) === 1,
      showProfile: false,
      showAccessViewSharedReports: Number(event.menu_id) === 9,
    };
    setActiveParentId(null)
    console.log("menuevent", event)
    if (Number(event.parent_id) === 2) {
      newActiveMenuItem.showReports = true
      setActiveTab(event);
    } else if (Number(event.parent_id) > 0) {
      setActiveTab(event);

    } else {
      setActiveTab(event);

    }
    console.log("newActiveMenuItem", newActiveMenuItem)
    setActiveMenuItem(newActiveMenuItem);

    if (event && Number(event.parent_id) === 2 && event.id) {
      const href = `/landing-page?id=${encodeURIComponent(event.id)}`;
      const current = `${location.pathname}${location.search}`;
      if (current !== href) {
        appliedMenuQuery.current = String(event.id);
        navigate(href);
      }
    }

  }


  const handleViewReportsClick = (event) => {
    (event.menu_id > 0) ? setActiveParentId(event.menu_id) : setActiveParentId(event.parent_id)

    // Also call setActiveMenuItems to properly navigate
    if (event.menu_id > 0) {
      console.log("Calling setActiveMenuItems with:", event);
      setActiveMenuItems(event);
    }
  }
  // useEffect(() => {
  //   const updateHeaderHeight = () => {
  //     if (headerRef.current) {
  //       setHeaderHeight(headerRef.current.offsetHeight-30); // +15px for gap
  //     }
  //   };
  //   updateHeaderHeight(); // Initial set
  //   window.addEventListener("resize", updateHeaderHeight); // Recalculate on resize
  //   console.log("headerHeight", headerHeight)
  //   return () => window.removeEventListener("resize", updateHeaderHeight);

  // }, [headerHeight]);
  useEffect(() => {
    if (!headerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeaderHeight(entry.contentRect.height - 30);
      }
    });

    observer.observe(headerRef.current);

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (MenuData && Array.isArray(MenuData)) {
      const updatedNavItems = MenuData.map(item => ({
        menu_id: item.menu_id,
        id: item.id || '',
        title: item.title || "Untitled",
        url: item.url || "#",
        parent_id: item.parent_id || null,
        sort_order: item.sort_order || 0,
        type: item.type || ""
      }));
      setNavItems(updatedNavItems);
    }
    if (FamilyData && Array.isArray(FamilyData)) {
      const updatedNavItemsFamily = FamilyData.map(item => ({
        dropdown_display_name: item.dropdown_display_name,
        family_account_id: item.family_account_id || "Untitled",
        relation_type_id: item.relation_type_id || "#",
        relation_type_name: item.relation_type_name || null,
        relative_name: item.relative_name || 0,
        user_id: item.user_id || "",
        user_name: item.user_name || item.UserName || item.email_address || '',
        first_name: item.first_name || item.First_Name || item.FirstName || '',
        last_name: item.last_name || item.Last_Name || item.LastName || '',
        email_address: item.email_address || item.EmailAddress || item.user_name || '',
      }));
      setFamilyItems(userRole === "Provider" ? [] : updatedNavItemsFamily);
    }
  }, [MenuData, activeParentId, FamilyData])

  // Initialize selectedFamilyMember from Redux store on component mount and when store changes
  useEffect(() => {
    if (selectedFamilyMemberFromStore) {
      setSelectedFamilyMember(selectedFamilyMemberFromStore);
      setSelectedUserId(selectedFamilyMemberFromStore.user_id);
    } else if (familyItems && familyItems.length > 0) {
      // If no family member is selected from store, default to the first family member
      const defaultMember = familyItems[0];
      setSelectedFamilyMember(defaultMember);
      setSelectedUserId(defaultMember.user_id);
    }
  }, [selectedFamilyMemberFromStore, familyItems]);

  const appliedMenuQuery = useRef('');
  const hadMenuQuery = useRef(false);
  useEffect(() => {
    try {
      sessionStorage.setItem('pmr_last_app_path', `${location.pathname}${location.search}`);
    } catch (e) {
      // ignore
    }
  }, [location.pathname, location.search]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const slug = params.get('id');
    const menu = params.get('menu');
    const menuIdParam = params.get('menuId');
    const menuKey = slug || menu || menuIdParam || '';

    if (!menuKey) {
      if (!navItems.length) return;
      if (appliedMenuQuery.current === 'dashboard') return;
      const dashboard = navItems.find((entry) => String(entry.id) === 'dashboard')
        || navItems.find((entry) => Number(entry.menu_id) === 1 && entry.parent_id == null)
        || navItems[0];
      if (!dashboard) return;
      hadMenuQuery.current = false;
      appliedMenuQuery.current = 'dashboard';
      setActiveMenuItems(dashboard);
      return;
    }

    if (appliedMenuQuery.current === menuKey) return;

    if (menu === 'profile') {
      appliedMenuQuery.current = menuKey;
      hadMenuQuery.current = true;
      setActiveMenuItems('profile');
      return;
    }

    if (!navItems.length) return;
    const item = (slug && navItems.find((entry) => String(entry.id) === slug))
      || (menu && menu !== 'profile' && navItems.find((entry) => String(entry.id) === menu))
      || (menuIdParam && navItems.find((entry) => Number(entry.menu_id) === Number(menuIdParam)));
    if (!item) return;
    appliedMenuQuery.current = menuKey;
    hadMenuQuery.current = true;
    setActiveMenuItems(item);
  }, [location.search, navItems]);

  const openedPasskeySecurity = useRef(false);
  useEffect(() => {
    const openProfile = () => {
      openedPasskeySecurity.current = true;
      setActiveMenuItems('profile');
    };
    window.addEventListener('pmr:open-passkey-security', openProfile);
    const cleanup = () => window.removeEventListener('pmr:open-passkey-security', openProfile);

    if (openedPasskeySecurity.current) return cleanup;

    const fromUrl = rememberPasskeySetupFromUrl();
    if (!fromUrl.setupPasskey && !shouldOpenPasskeySecurity()) {
      return cleanup;
    }

    const identity = login?.user_name || login?.email_address;
    if (!identity) return cleanup;

    const check = confirmPasskeySetupForLoggedInUser(identity);
    if (check.reason === 'pending') return cleanup;
    if (!check.ok) {
      openedPasskeySecurity.current = true;
      // Do not mark create-passkey offer on email mismatch — that wrongly
      // creates a new passkey on devices that are not the intended account.
      return cleanup;
    }
    openProfile();
    return cleanup;
  }, [login]);

  // Handle navigation from View Shared Reports button
  useEffect(() => {
    if (location.state?.showPatientSummary && location.state?.isFromDetails && userRole === "Provider") {
      // Set up the state to show patient summary/dashboard like TbListDetails click
      setActiveMenuItem(prev => ({
        ...prev,
        showSharedReports: false,
        showDashBoard: true,
      }));
      setActiveTab("All");
    }
  }, [location.state, userRole]);

  // useEffect(() => {
  //     if (familyItems && familyItems.length > 0 && !selectedFamilyMember) {
  //         const defaultMember = familyItems[0];
  //         setSelectedFamilyMember(defaultMember);
  //     }
  // }, [familyItems]);

  const handleFamilyMemberClick = (userId) => {
    const selectedMember = familyItems.find(member => member.user_id === userId);
    if (selectedMember) {
      console.log('Selected Family Member:', {
        user_id: selectedMember.user_id,
        name: selectedMember.dropdown_display_name,
        relation: selectedMember.relation_type_name
      });

      setSelectedFamilyMember(selectedMember);
      setSelectedUserId(selectedMember.user_id);
      // Removed redundant dispatch - CTNavbar already dispatches setSelectedFamilyMember

      // Preserve the current active menu item instead of always defaulting to Dashboard
      const currentActiveMenuItem = { ...activeMenuItem };
      
      // Only reset to Dashboard if no specific menu item is currently active
      const hasActiveMenu = Object.keys(currentActiveMenuItem).some(key => 
        key !== 'showDashBoard' && currentActiveMenuItem[key] === true
      );
      
      if (!hasActiveMenu) {
        // If no specific menu is active, default to Dashboard
        setActiveMenuItem({
          showUsersList: false,
          showUserReports: false,
          showSharedReports: false,
          showBlog: false,
          showPatientConversation: false,
          showBMI: false,
          showReport: false,
          showNotes: false,
          showAskAcme: false,
          showSecondOpinion: false,
          showProfile: false,
          showReceipt: false,
          showDashBoard: true,
          showReports: false,
          showViewSharedReports: false,
          showMedicalCondition: false,
          showScheduleForChildren: false,
          showScheduleByAge: false,
          showTrueContraindications: false,
          showAdministeringVaccinesToAdults: false,
          showChangePassword: false,
        });
        setActiveTab("All");
      }
      // If there's an active menu item, keep it as is - don't reset to Dashboard

      setActiveParentId(null);
    }
  };

  const handleChangePasswordClose = () => {
    setActiveMenuItem(prev => ({
      ...prev,
      showChangePassword: "",
    }));
  };
  if (!hasValidSession) {
    const setupParams = new URLSearchParams(location.search);
    const setupEmail = setupParams.get('email') || '';
    const loginPath = setupParams.get('setupPasskey') === '1'
      ? `/?setupPasskey=1&email=${encodeURIComponent(setupEmail)}`
      : '/';
    return <Navigate to={loginPath} replace />;
  }

  return (
    <div >
      <div>
        <React.Fragment>
          <div className="fixed-top" ref={headerRef} style={{ verticalAlign: "center", flex: 1, alignContent: 'center', alignItems: 'center' }}>
            <div style={{ backgroundColor: '#f8f9fa' }}>
              <div className="shadow-lg">
                <TopHeader
                  showAccountSettings={setActiveMenuItems}
                  showChangePassword={setActiveMenuItems}
                  onLogoClick={() => {
                    if (userRole === "Provider") {
                      setActiveMenuItem({
                        showUsersList: false,
                        showUserReports: false,
                        showSharedReports: true,
                        showBlog: false,
                        showPatientConversation: false,
                        showBMI: false,
                        showReport: false,
                        showNotes: false,
                        showAskAcme: false,
                        showSecondOpinion: false,
                        showProfile: false,
                        showReceipt: false,
                        showDashBoard: false,
                        showReports: false,
                        showViewSharedReports: false,
                        showMedicalCondition: false,
                        showScheduleForChildren: false,
                        showScheduleByAge: false,
                        showTrueContraindications: false,
                        showAdministeringVaccinesToAdults: false,
                        showChangePassword: false,
                        showAccessDashboard: false,
                        showAccessViewSharedReports: false,
                      });
                      setActiveTab("With You");
                      setActiveParentId(null);
                    } else {
                      setActiveMenuItems({ menu_id: 1, parent_id: null });

                    }
                  }}
                  hideProfile={userRole === "Provider"}
                />
              </div>
              <div className="mx-3 py-2">
                <CTNavbar
                  navItems={navItems}
                  familyItems={familyItems}
                  activeTab={activeTab}
                  setDashboard={setActiveMenuItems}
                  setActiveTab={setActiveTab}
                  activeParentId={activeParentId}
                  onFamilyMemberClick={handleFamilyMemberClick}
                  selectedUserId={selectedUserId}
                  activeMenuItem={activeMenuItem}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>

      <div className="container-fluid" style={{ paddingTop: `${headerHeight - 15}px` }}>
        {userRole === "User" && <UserLandingPage userId={selectedUserId} activeMenuItem={activeMenuItem} activeTab={activeTab} onViewReportsClick={handleViewReportsClick} selectedFamilyMember={selectedFamilyMember} onChangePasswordClose={handleChangePasswordClose} />}
        {userRole === "Provider" && <ProviderLandingPage userId={selectedUserId} activeMenuItem={activeMenuItem} activeTab={activeTab} onViewReportsClick={handleViewReportsClick} />}
        {userRole === "Admin" && <AdminLandingPage />}
        {accessType === "User" && <AccessLandingPage activeTab={activeTab} activeMenuItem={activeMenuItem} onViewReportsClick={handleViewReportsClick} setActiveMenuItem={setActiveMenuItem} setActiveMenuItems={setActiveMenuItems} />}
      </div>
    </div>
  );
};

export default LandingPage;

